import { useCallback, useState } from 'react'
import { usePreviewStore } from './use-preview-store'
import { useProjectStore } from './use-project-store'

/**
 * @description 回滚操作，回滚到指定 index 的 fileSystemTree
 * 已考虑的 fork 项目的回滚
 */
export const useProjectRestore = () => {
  const { checkoutVersion } = useProjectStore()
  const [restoringVersion, setRestoringVersion] = useState<number | undefined>()
  const { updatePreview } = usePreviewStore()

  const restore = useCallback(
    async (index?: number) => {
      if (restoringVersion) return
      setRestoringVersion(index)
      await checkoutVersion(index)
      await updatePreview()
      setRestoringVersion(undefined)
    },
    [checkoutVersion, updatePreview, restoringVersion],
  )

  return { restore, restoringVersion }
}
